// @flow

import { getQuery } from '../../common'

import { type IframePayload } from '../../common/iframeMessageTypes'
import { IFRAME_ORIGIN } from '../../common/iframeParameters'

export function postMessageToParent (payload: IframePayload) {
  if (window.parent?.postMessage) {
    const parentOrigin = getQuery(IFRAME_ORIGIN)
    window.parent.postMessage(JSON.stringify(payload), parentOrigin)
  }
}
